/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ConnectedByV1Dto = {
  /**
   * The unique identifier of the Entity.
   */
  id: string;
  /**
   * the typo of the connection
   */
  connectionType: ConnectedByV1Dto.connectionType;
};
export namespace ConnectedByV1Dto {
  /**
   * the typo of the connection
   */
  export enum connectionType {
    TICKET = 'Ticket',
    POINT_OF_SALE = 'PointOfSale',
    CONTRACT = 'Contract',
    AREA = 'Area',
  }
}
